<template>
  <button
    class="
      select-none
      px-4
      py-3
      text-secondary
      font-bold
      bg-black
      rounded-lg
      transition-default
      hover:bg-accent
    "
    :class="{
      'cursor-not-allowed': isLoading,
    }"
    :disabled="isLoading"
  >
    <div class="flex items-center">
      <div v-if="isLoading" class="relative w-6 mr-3"><SpinLoaderSmall /></div>
      <slot />
    </div>
  </button>
</template>

<script>
import SpinLoaderSmall from "@/components/UI/Loader/SpinLoaderSmall";
export default {
  name: "MediumButton",
  components: {
    SpinLoaderSmall,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>